import React, { useEffect, useState } from "react";
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  IconButton,
  InputAdornment
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import ClearIcon from "@mui/icons-material/Clear";
import "./LoginPage.css";
import logo from "../static/media/login/logo_login.webp";
import "../index.css";

const LoginPage = () => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Login | Ash Tech";
    window.scrollTo(0, 0);
  }, []);

  const fetchCSRFToken = async () => {
    try {
      const res = await fetch("/sistema/get-csrf-token/", {
        method: "GET",
        credentials: "include"
      });
      const data = await res.json();
      return data.csrfToken;
    } catch {
      return null;
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!formData.email || !formData.password) {
      setError("Todos los campos son obligatorios.");
      return;
    }

    const csrfToken = await fetchCSRFToken();
    if (!csrfToken) {
      setError("No se pudo obtener el token CSRF.");
      return;
    }

    try {
      const response = await fetch("/sistema/login/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": csrfToken
        },
        credentials: "include",
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem("is_logged_in", "true");
        localStorage.setItem("user_email", data.email || "");
        localStorage.setItem("is_superuser", String(data.is_superuser));
        localStorage.setItem("is_admin", String(data.is_admin));
        localStorage.setItem("is_vendedor", String(data.is_vendedor));

        const isSystemUser =
          data.is_superuser || data.is_admin || data.is_vendedor;

        if (data.requiere_cambio_clave) {
          if (isSystemUser) {
            navigate("/system/update-password", { state: { email: data.email } });
          } else {
            navigate("/update-password", { state: { email: data.email } });
          }
          return;
        }

        if (data.is_superuser || data.is_admin || data.is_vendedor) {
          navigate("/admin-panel");
          return;
        }

        navigate("/user-panel");
      } else {
        setError(data.error || "Credenciales incorrectas.");
      }
    } catch {
      setError("Error de conexión con el servidor.");
    }
  };

  return (
    <div className="login-container">
      <div className="overlay">
        <Container maxWidth="xs" className="login-form">
          <Box textAlign="center">
            <img src={logo} alt="Logo" className="login-logo" />
          </Box>

          <Typography variant="h5" align="center" gutterBottom className="login-title">
            Iniciar Sesión
          </Typography>

          {error && <Typography className="error-message">{error}</Typography>}

          <form onSubmit={handleSubmit}>
            <TextField
              label="Correo Electrónico"
              variant="outlined"
              fullWidth
              margin="normal"
              name="email"
              value={formData.email}
              onChange={handleChange}
              InputProps={{
                className: "input-field",
                endAdornment: formData.email && (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setFormData({ ...formData, email: "" })}>
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                )
              }}
              InputLabelProps={{ className: "input-label" }}
            />

            <TextField
              label="Contraseña"
              type={showPassword ? "text" : "password"}
              variant="outlined"
              fullWidth
              margin="normal"
              name="password"
              value={formData.password}
              onChange={handleChange}
              InputProps={{
                className: "input-field",
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword((prev) => !prev)}>
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
              InputLabelProps={{ className: "input-label" }}
            />

            <Button type="submit" variant="contained" fullWidth className="login-button">
              INGRESAR
            </Button>

          </form>
        </Container>
      </div>
    </div>
  );
};

export default LoginPage;
